// extracted by mini-css-extract-plugin
export var aboveInput = "_lx-0";
export var actionButton = "_lx-5";
export var actionButtonContainer = "_lx-1";
export var actionIcon = "_lx-6";
export var aiInfoContainer = "_lx-2";
export var attachmentWrapper = "_lx-7";
export var bold = "_lx-3";
export var checkIcon = "_lx-8";
export var clickingRecipientBar = "_lx-11";
export var commentThreadSwitch = "_lx-a";
export var draftImage = "_lx-b";
export var draftImageContainer = "_lx-c";
export var draftImages = "_lx-e";
export var editButton = "_lx-g";
export var editor = "_lx-f";
export var editorContainer = "_lx-y";
export var editorErrorTooltipWrapper = "_lx-9";
export var headerDivider = "_lx-h";
export var icon = "_lx-i";
export var info = "_lx-j";
export var internal = "_lx-n";
export var internalDivider = "_lx-k";
export var internalMessage = "_lx-l";
export var messageInputCard = "_lx-m";
export var messageInputForm = "_lx-o";
export var messageInputFormInternal = "_lx-p";
export var options = "_lx-q";
export var publicMessageCustomer = "_lx-s";
export var publicMessageMerchant = "_lx-r";
export var removeImageButton = "_lx-d";
export var replyButtons = "_lx-t";
export var showSignatureButton = "_lx-u";
export var spinner = "_lx-v";
export var verticalButtonDivider = "_lx-4";
export var visibilitySelector = "_lx-w";
export var warning = "_lx-x";
export var wrappingText = "_lx-z";
export var writingInternalNoteTopBorder = "_lx-10";